import React from "react";
import axios from "axios"
import Loader from "./Loader";


const checkInternetConnection = async () => {
    try {
        await axios.get("https://bo.ava.do/ping");
        return true;
    } catch (e) {
        return false;
    }
}

const CheckInternetConnection = ({ onSuccess }) => {

    const [loading, setLoading] = React.useState(true);
    const [isOnline, setIsOnline] = React.useState(false);
    const [collapsed, setCollapsed] = React.useState(false);


    const check = () => {
        if (!isOnline) {
            checkInternetConnection().then((online) => {
                if (online) {
                    setIsOnline(online);
                    onSuccess();
                }
                setLoading(false);
            })
        }
    }

    React.useEffect(() => {
        //const i = setTimeout(check, 5000);
        check();

        // return () => {
        //     if (i) {
        //         clearInterval(i);
        //     }
        // }
    });




    if (loading) {
        return (
            <Loader />
        );
    }

    if (!isOnline) {
        return (
            <>
                <Loader />
                <div>No internet detected.</div>
                <ul><li>Make sure your AVADO is connected to your internet router. <button onClick={() => {
                    setCollapsed(!collapsed);
                }}>More</button></li>
                    {!collapsed && (
                        <>
                            <li>Check if you're not connected to another VPN</li>
                            <li>Check if you don't have any custom DNS servers set</li>
                            <li>Check if the orange and green LED's are on on the network plug of the AVADO</li>
                            <li>Try shutting  down your AVADO by pressing the power button it</li>
                        </>
                    )}
                </ul>
            </>
        )
    } else {

        return (null)
    }

}

export default CheckInternetConnection;
